import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import axios, { endpoints } from 'src/utils/axios';
import Toolbar from '@mui/material/Toolbar';
import { Box, Popover, Typography } from '@mui/material';
import Badge, { badgeClasses } from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
// theme
import { bgBlur } from 'src/theme/css';
import { m } from 'framer-motion';

// hooks
import { MdOutlineLightMode } from 'react-icons/md';
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
import { useAuthContext } from 'src/auth/hooks';
import SvgColor from 'src/components/svg-color';
import { useSettingsContext } from 'src/components/settings';
//
import { varHover } from 'src/components/animate';
import { PiBell } from 'react-icons/pi';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

import { HEADER, NAV } from '../config-layout';
import { AccountPopover, NotificationsPopover, SettingsButton } from '../_common';

// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {
  const theme = useTheme();
  const auth = useAuthContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const settings = useSettingsContext();
  const [notification, setNotification] = useState([]);
  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');

  const offset = useOffSetTop(HEADER.H_DESKTOP);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const fetchData = async () => {
    if (auth.user.roleType !== 5) {
      try {
        const response = await axios.get(`${endpoints.announcement.not}${auth.user.id}`);
        if (response && response.data) {
          setNotification(response.data.announcements);
        }
      } catch (err) {
        // // console.log(err);
      }
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const offsetTop = offset && !isNavHorizontal;

  const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}

      {!lgUp && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
        </IconButton>
      )}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1 }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <SettingsButton sx={{ mr: 2 }} />

          {/* <Badge

            color="error"
            variant="dot"
            invisible={notification.length <= 0} // Show dot only if there are notifications
            sx={{
              mr:2,
              [`& .${badgeClasses.badge}`]: {
                top: 8,
                right: 8,
              },
            }}
          >
            <Box
              component={m.div}
          
              
            >
              <IconButton
                component={m.button}
                whileTap="tap"
                whileHover="hover"
                variants={varHover(1.05)}
                aria-label="notifications"
                sx={{
                  width: 40,
                  height: 40,
                }}
         
              >
<Box sx={{mt:1,mr:2,ml:1, color:'#7068FF'}}>
    <PiBell style={{ fontSize: "1.5rem" }}/>
    </Box>
               
              </IconButton>
            </Box>
          </Badge>  */}

          {/* <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              p: 2,
              minWidth: 280,
              borderRadius: 2,
              boxShadow: 3,
              maxHeight: 300,
              overflowY: "auto",
            },
          },
        }}
      >
        {notification.length > 0 ? (
          notification.map((note, idx) => (
            <Box key={idx} sx={{ mb: 1 }}>
              <Typography variant="subtitle2" fontWeight="bold">
                {note.priority?.toUpperCase()}
              </Typography>
              <Typography variant="body2">{note.description}</Typography>
            </Box>
          ))
        ) : (
          <Typography>No new notifications</Typography>
        )}
      </Popover> */}

          {/* <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
              paper: {
                sx: {
                  p: 2,
                  minWidth: 280,
                  borderRadius: 2,
                  boxShadow: 3,
                  maxHeight: 300,
                  overflowY: "auto",
                },
              },
            }}
          >
            {notification.length > 0 ? (
              notification.map((note, idx) => (
                <Box key={idx} sx={{ mb: 1 }}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {note.priority?.toUpperCase()}
                  </Typography>
                  <Typography variant="body2">{note.description}</Typography>
                </Box>
              ))
            ) : (
              <Typography>No new notifications</Typography>
            )}
          </Popover> */}
          <Box sx={{ mr: 1 }}>
            <NotificationsPopover />
          </Box>

          <AccountPopover />
        </Box>
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
